import { Grid, Typography } from "@mui/material";
import { useResponsive } from "../../../Modulo_Responsive/Hooks/useResponsive";
import equipo from "../../../Recursos/equipo.webp";

const Operacion_Home = () => {
    const { sCell, sTab } = useResponsive();

    const bullets = [
        "Personal técnico certificado",
        "Supervisión bajo normativa SST",
        "Respuesta ágil en operación activa",
        "Trazabilidad y respaldo documental",
    ];

    return (
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            size={{ xs: 12 }}
            sx={{ background: "#F5F6F7", py:sCell?8:16 }}
            component="section"
        >
            <Grid
                container
                justifyContent="flex-start"
                alignItems="flex-start"
                size={{ xs: 12, sm: 12, md: 10 }}
                sx={{ maxWidth: 1400, px: 3 }}
            >
                <Grid
                    container
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    size={{ xs: 12, sm: 12, md: 12 }}
                >
                    <Grid
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        size={{ xs: 12, sm: 6, md: 6 }}
                        sx={{ pr: sCell ? 0 : 6, mb: sCell ? 6 : 0 }}
                    >
                        <Grid
                            container
                            justifyContent="flex-start"
                            alignItems="flex-start"
                            size={{ xs: 12, sm: 12, md: 12 }}
                        >
                            <Typography
                                component="h2"
                                variant="h2"
                                sx={{
                                    textAlign: sCell ? "center" : "left",
                                    mb: 4,
                                }}
                            >
                                ¿Por qué elegir Espacio Compacto?
                            </Typography>
                        </Grid>

                        <Grid container direction="column" gap={2}>
                            {bullets.map((item, index) => (
                                <Grid
                                    key={index}
                                    container
                                    alignItems="center"
                                    gap={1.5}
                                    justifyContent={"flex-start"}
                                >
                                    <Grid
                                        sx={{
                                            width: 7,
                                            height: 7,
                                            borderRadius: "50%",
                                            background: "#F5F6F7",
                                            flexShrink: 0,
                                        }}
                                    />
                                    <Typography
                                        component="p"
                                        variant="body1"
                                        sx={{
                                            textAlign: sCell ? "left" : "left",
                                            color: "#000",
                                        }}
                                    >
                                        {item}
                                    </Typography>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>

                    {/* Columna derecha: imagen */}
                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                        <Grid
                            container
                            justifyContent={sCell ? "center" : "flex-end"}
                        >
                            <Grid
                                loading="lazy"
                                component="img"
                                src={equipo}
                                alt="Equipo de trabajo profesional"
                                sx={{
                                    width: "100%",
                                    maxWidth: sCell ? "100%" : 480,
                                    height: sCell ? 220 : 300,
                                    objectFit: "cover",
                                    display: "block",
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Operacion_Home;